import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { isEmpty } from 'lodash';
import { MyAddresses, DeleteAddressModal } from '@desquared/wave-components-library';
import { updateUser, createUserAddress, deleteUserAddress, updateUserAddress } from '@/api/users';
import User from '@/store/user';
import { ResponsiveMenuStore } from '@/store/sideSheet';
import NoAddressesFound from '../../../public/assets/wave-grocery/Empty-States-Default/Address.png';
import AddressViewAside from '@/components/AddressViewAside/AddressViewAside';
import { geoCodePostal } from '@/api/AddressLatLng';
import useWindowUnderThreshold from '@/hooks/useWindowUnderThreshold';
import { AddressViewSideSheetStore } from '@/store/sideSheet';
import { getAddressList, getAddressType } from '@/utils/addressUtilities';
import { useTranslations } from 'next-intl';
import CUSTOM_STYLES from '@/utils/modalStyle';
import styles from '@/styles/User.module.css';
import Cookies from 'universal-cookie';
import { hasEmptyKey } from '@/utils/maskEmail';
import { getShopsV3 } from '@/api/Shops';
import useDeliveryServices from '@/hooks/useDeliveryServices';
import { Shop } from '@/store/shop';

export default function AddressesSection({ user, image, config }) {
  const mainAddress = User.getUserMainAddress();
  const isMobile = useWindowUnderThreshold(950);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const cookies = new Cookies();
  const { selectedService } = useDeliveryServices();

  const token = cookies.get('token');

  // const { token } = user;
  const [addressViewSideSheet, setAddressViewSideSheet] = useState(false);
  const [toDelete, setToDelete] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [isNotEligible, setIsNotEligible] = useState(false);
  const [isNotEligibleText, setIsNotEligibleText] = useState('');

  const [toEdit, setToEdit] = useState('');

  const [addresses, setAddresses] = useState(user.addresses);
  const t = useTranslations();
  const ADDRESS_ERROR_MESSSAGE = t('user_address.create_error');
  const openMenu = () => {
    ResponsiveMenuStore.open();
  };

  const onEdit = e => {
    setIsEdit(true);
    setToEdit(e);
    setAddressViewSideSheet(true);
    const selectedAdd = addresses.find(element => element._id === e);
    setSelectedIndex(addresses.findIndex(element => element._id === e));
    AddressViewSideSheetStore.open('profile');
  };

  const onDeleteClick = id => {
    setToDelete(id);
    setSelectedIndex(addresses.findIndex(element => element._id === id));
    setShowDeleteModal(true);
  };

  async function addAddress(newAddress) {
    setIsNotEligibleText('');
    setIsNotEligible(false);
    const isMain = newAddress.isMainAddress;
    const formated = formToAddress(newAddress);
    const addressToCreate = { address: [{ ...formated }] };
    newAddress.type = getAddressType(newAddress.addressType);
    newAddress.contactPhone = newAddress.phone;

    if (newAddress.type === undefined) newAddress.type = 'home';
    const { notice: _n, ...addressToValidate } = newAddress;
    let fieldsPopullated = !hasEmptyKey(addressToValidate);
    if (!fieldsPopullated && !process.env.hasStoreNecessary) {
      setIsNotEligibleText(t('user_address.edit_fields_error'));
      setIsNotEligible(true);
    }
    if (process.env.hasStoreNecessary) {
      const shopsV3 = await getShopsV3(selectedService?.id, newAddress.postalCode);
      if (!shopsV3?.shops || shopsV3?.shops?.length === 0) {
        setIsNotEligibleText(t('user_address.no_service'));
        setIsNotEligible(true);
        return;
      }
    }
    if (
      (process.env.hasStoreNecessary &&
        newAddress?.postalCode?.length !== 0 &&
        newAddress?.street?.length !== 0 &&
        newAddress?.streetNo?.length !== 0) ||
      (fieldsPopullated && !process.env.hasStoreNecessary)
    ) {
      const response = await createUserAddress(token, newAddress);
      if (response?.data) {
        setAddresses(prevAddresses => [...prevAddresses, response?.data]);
        AddressViewSideSheetStore.close('profile');
        setAddressViewSideSheet(false);
      } else {
        setIsNotEligibleText(response.response?.data?.userMessage ?? ADDRESS_ERROR_MESSSAGE);
        setIsNotEligible(true);
      }
    } else {
      setIsNotEligibleText(t('user_address.edit_fields_error'));
      setIsNotEligible(true);
    }
  }

  useEffect(() => {
    const $AddressView = AddressViewSideSheetStore.subscribe(setAddressViewSideSheet);

    return () => {
      $AddressView.unsubscribe();
    };
  }, []);

  async function updateDetails() {
    if (selectedIndex === -1) {
      return;
    }
    const addressSelected = addresses[selectedIndex];
    const tempUser = { ...user };
    if (Object.keys(addressSelected).length !== 0 && addressSelected.constructor === Object) {
      tempUser.addresses[selectedIndex].isAvailable = !tempUser?.addresses[selectedIndex].isAvailable;
    }
    delete tempUser.email;

    const updatedUser = await updateUser(token, tempUser);
    if (updatedUser?.error) {
      return;
    }
    const mainAdress = updatedUser?.addresses?.find(address => address._id === tempUser?.mainAddress);
    if (isEmpty(mainAdress)) {
      User.updateMainAddress(null);
    }

    User.update(updatedUser);
    setAddresses(addresses.filter(ele => !(ele._id === addressSelected._id)));
  }

  const formToAddress = address => {
    const newAddress = { ...addresses };
    delete newAddress.isMainAddress;
    newAddress.contactPhone = newAddress.countryOption + newAddress.phone;

    delete newAddress.phone;
    delete newAddress.countryOption;
    switch (newAddress.addressType) {
      case 0:
        newAddress.type = 'home';
        break;
      case 1:
        newAddress.type = 'work';
        break;
      case 2:
        newAddress.type = 'other';
        break;
    }
    delete newAddress.addressType;
    return newAddress;
  };
  async function editAddress(editAddress) {
    setIsNotEligibleText('');
    setIsNotEligible(false);
    // const isMain = editAddress.isMainAddress;
    const res = await geoCodePostal(editAddress.postalCode);
    // if (!res?.data?.lat || !res?.data?.lng) {
    //   return;
    // }
    editAddress.type = getAddressType(editAddress.addressType);
    editAddress.contactPhone = editAddress.phone;

    const { notice: _n, ...addressToValidate } = editAddress;

    let fieldsPopullated = !hasEmptyKey(addressToValidate);

    if (!fieldsPopullated && !process.env.hasStoreNecessary) {
      setIsNotEligibleText(t('user_address.edit_fields_error'));
      setIsNotEligible(true);
    }
    if (process.env.hasStoreNecessary) {
      const shopsV3 = await getShopsV3(selectedService?.id, editAddress.postalCode);
      if (!shopsV3?.shops || shopsV3?.shops?.length === 0) {
        setIsNotEligibleText(t('user_address.no_service'));
        setIsNotEligible(true);
        return;
      }
    }
    if (
      (process.env.hasStoreNecessary &&
        editAddress?.postalCode?.length !== 0 &&
        editAddress?.street?.length !== 0 &&
        editAddress?.streetNo?.length !== 0) ||
      (fieldsPopullated && !process.env.hasStoreNecessary)
    ) {
      const response = await updateUserAddress(token, editAddress, toEdit);

      if (response?.data) {
        const newAddresses = [...addresses];
        const addressIndex = user?.addresses?.findIndex(ele => ele._id === toEdit);
        newAddresses[addressIndex] = response.data;
        setAddresses(newAddresses);
        AddressViewSideSheetStore.close('profile');
        setAddressViewSideSheet(false);
      } else {
        setIsNotEligibleText(response.response?.data?.userMessage ?? ADDRESS_ERROR_MESSSAGE);
        setIsNotEligible(true);
      }
    } else {
      setIsNotEligibleText(t('user_address.edit_fields_error'));
      setIsNotEligible(true);
    }
  }
  const onNewAddress = () => {
    setIsNotEligibleText('');
    setIsNotEligible(false);
    setIsEdit(false);
    setToEdit('');
    setSelectedIndex(-1);
    AddressViewSideSheetStore.open('profile');
    setAddressViewSideSheet(true);
  };

  async function deleteAddress() {
    const response = await deleteUserAddress(token, toDelete);
    const deleted = addresses.filter(ele => !(ele._id === toDelete._id));
    if (response) setAddresses(addresses.filter(ele => !(ele._id === toDelete)));
    const latestAddresses = addresses.filter(ele => !(ele._id === toDelete));
    if (latestAddresses.length === 0) {
      Shop.reset();
    }
  }

  if (!user) return null;
  return (
    <>
      {showDeleteModal && (
        <ReactModal
          isOpen={showDeleteModal}
          onRequestClose={() => {
            setShowDeleteModal(false);
          }}
          style={CUSTOM_STYLES}
          contentLabel={'delete modal'}
          ariaHideApp={false}
          className={cn(styles.modalContainer, styles.modal)}
          shouldCloseOnOverlayClick={true}
        >
          <DeleteAddressModal
            title={t('user_address.delete_modal.title')}
            description={t('user_address.delete_modal.description')}
            cancelWording={t('user_address.delete_modal.cancel')}
            onDelete={id => {
              // updateDetails();
              deleteAddress(id);
              setShowDeleteModal(false);
              setSelectedIndex(-1);
              setToDelete('');
            }}
            onCancel={() => {
              setShowDeleteModal(false);
              setSelectedIndex(-1);
              setToDelete('');
            }}
            deleteWording={t('user_address.delete_modal.delete')}
          />
        </ReactModal>
      )}

      {AddressViewSideSheetStore.isFromProfile() && (
        <AddressViewAside
          setIsNotEligibleText={setIsNotEligibleText}
          setIsNotEligible={setIsNotEligible}
          handleClose={() => {
            AddressViewSideSheetStore.close('profile');
            setToEdit('');
            setSelectedIndex(-1);
          }}
          isEdit={isEdit}
          selectedAddress={toEdit}
          user={user}
          isNotEligible={isNotEligible}
          notEligibleWording={isNotEligibleText}
          config={config}
          onSubmit={e => {
            if (isEdit) {
              editAddress(e);
            } else {
              addAddress(e);
            }
          }}
        />
      )}
      <MyAddresses
        title={t('user_address.title')}
        addNewText={t('user_address.add_new')}
        mainAddressWording={t('user_address.main_address')}
        noItemsFoundWording={t('user_address.no_items')}
        addItemWording={t('user_address.add')}
        noItemsFoundImage={image ? image : NoAddressesFound.src}
        ItemList={getAddressList(
          addresses,
          onEdit,
          onDeleteClick,
          onNewAddress,
          isMobile,
          mainAddress,
          t,
          config?.format?.addressStreetPattern
        )}
        onAdd={() => {
          onNewAddress();
        }}
        onBack={() => {
          openMenu();
        }}
      />
    </>
  );
}
